export const content = {
  name: 'Services',
  description: `We provide a comprehensive suite of financial and operational services, offering clients 
                the expertise and support of a full-service financial team. We work closely with our clients as 
                trusted partners, embedding ourselves as an essential part of their leadership teams. Committed 
                to each engagement, we meet regularly, collaborate directly with teams, and take a proactive, 
                hands-on approach to drive success.`,
};


export const services = [
  {
    title: "Chief Financial Officer",
    details: [
      "Restructuring process advisory including legal, accounting and finance",
      "Capital raise support, sourcing of investors, and process assistance",
      "M&A advisory",
      "Strategic business advice",
      "Contract review and negotiation",
      "Insurance renewal optimization",
      "Accounting quality control, oversight, and review",
      "Board meeting attendance",
    ],
  },
  {
    title: "Controller",
    details: [
      "Financial statement analysis",
      "Internal control implementation",
      "Treasury management",
      "Audit and Tax Management",
      "Process optimization",
    ],
  },
  {
    title: "Accounting & Bookkeeping",
    details: [
      "Data entry recording revenue (A/R) and expenses (A/P)",
      "Bank transaction posting",
      "Credit card transaction posting",
      "Bank reconciliation",
      "Credit card reconciliation",
      "Balance sheet schedules and maintenance",
      "Financial statement reporting",
      "Sales tax reporting",
      "Payroll processing",
      "Tip reconciliation",
    ],
  },
  {
    title: "Financial Reporting & Supply Chain Analysis",
    details: [
      "Custom tailored reporting based on your specifications and needs",
      "Budgeting & forecasting",
      "Cash flow modeling",
      "Master distributor agreement negotiations & analysis",
      "Menu price analysis",
      "COGS analysis",
    ],
  },
  {
    title: "Brand Management",
    details: [
      "Marketing Communications Programming & Implementation",
      "Branding, Storytelling, PR & Message Development",
      "3rd party delivery platform marketing & promotion management",
      "Social channel management",
      "Creative Project Management (website, ad campaigns, etc.)",
      "Content Conception & Direction",
      "Loyalty program optimization",
      "Marketing strategy ROI evaluation",
    ],
  },
  {
    title: "Operational Consulting",
    details: [
      "Standard Operating Procedure development",
      "Team training",
      "Delivery and food tech consulting",
      "Restaurant buildout support",
      "Hiring support",
      "Launch strategy support",
    ],
  },
  {
    title: "Human Resources",
    details: [
      "Compliance Support",
      "Onboarding & Offboarding",
      "Employee Files & Recordkeeping",
      "Payroll & Timekeeping Support",
      "Workplace Training",
      "General HR Advisory",
    ],
  },
  {
    title: "Implementation Assistance",
    details: [
      "POS implementation expertise / mapping",
      "Invoice approvals software implementation",
      "Expense reimbursement software integration",
      "Accounting software transition project management",
    ],
  },
  {
    title: "Information Technology",
    details: [
      "Build IT systems / infrastructure",
      "API integrations",
      "Execute physical build outs and installs",
      "Manage vendor relations & analyze cost",
      "Support store level operations (POS, printers, computers, etc.)",
      "PCI compliance",
      "Geolocation & geofencing assistance",
    ],
  },
];
